export default "__VITE_ASSET__BkgPrujF__"